import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { defineMessages, injectIntl } from 'react-intl';

import Icon from 'components/Icon';

class DismissibleAlert extends PureComponent {
  static propTypes = {
    /**
     * Child text/nodes
     */
    children: PropTypes.node.isRequired,

    /**
     * Additional classes to apply
     */
    className: PropTypes.string.isRequired,

    /**
     * Renders an Icon component
     */
    icon: PropTypes.node,

    /**
     * Defines what to do during 'onDismiss' event
     */
    onDismiss: PropTypes.func,

    /**
     * Prop from react-intl HOC
     *
     * @ignore
     */
    intl: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  };

  static defaultProps = {
    icon: null,
    onDismiss: null,
  };

  constructor(props) {
    super(props);

    this.state = { isDismissed: false };
    this.onDismiss = this.onDismiss.bind(this);
  }

  onDismiss(event) {
    const { onDismiss } = this.props;

    this.setState({ isDismissed: true });

    if (onDismiss) {
      onDismiss(event);
    }
  }

  render() {
    const { children, className, icon, intl } = this.props;

    const messages = defineMessages({
      ariaLabel: {
        defaultMessage: 'Dismiss alert',
        description: 'DismissibleAlert ariaLabel',
      },
    });

    return (
      !this.state.isDismissed && (
        <div className={className} role="alert">
          {icon}
          <div className="Alert__content">{children}</div>
          <button
            className="Alert__dismiss"
            type="button"
            aria-label={intl.formatMessage(messages.ariaLabel)}
            onClick={this.onDismiss}
          >
            <Icon type="close" />
          </button>
        </div>
      )
    );
  }
}

export default injectIntl(DismissibleAlert);
